import { useState, createContext,useEffect } from "react";
import { localStorageKeys } from "../utils/mappings";
export const FilterContext = createContext();

export const FilterProvider = (props) => {
  const [workboardFilters, setWorkboardFilters] = useState(
    JSON.parse(localStorage.getItem(localStorageKeys.WORKBOARD_FILTERS)) || {}
  );
  const [project, setProject] = useState(JSON.parse(localStorage.getItem("dash_proj")) || { id: "", name: "" });
  const [dashProperty, setDashProperty] = useState(JSON.parse(localStorage.getItem("dash_prop")) || []);
  const [property, setProperty] = useState({ id: "", name: "" });
  const [cohort, setCohort] = useState({ id: "", name: "" });
  const [member, setMember] = useState({ id: "", name: "" });
  const [team, setTeam] = useState({ id: "", name: "" });
  const [status, setStatus] = useState({ id: "", status: "" });
  const [selectedProjectList, setSelectedProjectList] = useState(workboardFilters?.projects || []);
  const [selectedPropertyList, setSelectedPropertyList] = useState(workboardFilters?.properties || []);
  const [selectedCohortList, setSelectedCohortList] = useState([]);
  const [selectedStatusList, setSelectedStatusList] = useState([]);
  const [selectedMemberList, setSelectedMemberList] = useState(workboardFilters?.members || []);
  const [selectedTeamList, setSelectedTeamList] = useState([]);
  //for Dashboard section
  const [selectedDashboardProjectList, setSelectedDashboardProjectList] = useState([]);
  const [selectedDashboardPropertyList, setSelectedDashboardPropertyList] = useState([]);

  const handleDashboardProject = (proj) => {
    localStorage.setItem("dash_proj", JSON.stringify(proj));
    setProject(proj);
  };

  const handleDashboardProperty = (prop) => {
    localStorage.setItem("dash_prop", JSON.stringify(prop));
    setDashProperty(prop);
  };

  const saveWorkboardFilters = (filters) => {
    localStorage.setItem(
      localStorageKeys.WORKBOARD_FILTERS,
      JSON.stringify(filters)
    );
    setWorkboardFilters(filters);
  };
  
  const patchWorkboardFilters = (patch) => {
    setWorkboardFilters((prev) => {
      const next = { ...prev, ...patch };
      localStorage.setItem(
        localStorageKeys.WORKBOARD_FILTERS,
        JSON.stringify(next)
      );
      return next;
    });
  };

  useEffect(() => {
    patchWorkboardFilters({
      projects: selectedProjectList,
      properties: selectedPropertyList,
      members: selectedMemberList,
    });
  }, [selectedProjectList, selectedPropertyList, selectedMemberList]);

  const state = {
    project,
    property,
    cohort,
    member,
    team,
    status,
    dashProperty,
    workboardFilters,
    selectedProjectList,
    selectedPropertyList,
    selectedCohortList,
    selectedStatusList,
    selectedMemberList,
    selectedTeamList,
    selectedDashboardProjectList,
    selectedDashboardPropertyList,
  };

  return (
    <FilterContext.Provider
      value={{
        project: state.project,
        property: state.property,
        cohort: state.cohort,
        member: state.member,
        team: state.team,
        status: state.status,
        dashProperty: state.dashProperty,
        selectedProjectList: state.selectedProjectList,
        selectedPropertyList: state.selectedPropertyList,
        selectedCohortList: state.selectedCohortList,
        selectedStatusList: state.selectedStatusList,
        selectedMemberList: state.selectedMemberList,
        selectedTeamList: state.selectedTeamList,
        selectedDashboardProjectList: state.selectedDashboardProjectList,
        selectedDashboardPropertyList: state.selectedDashboardPropertyList,
        workboardFilters: state.workboardFilters,
        saveWorkboardFilters,
        setProject,
        setProperty,
        setCohort,
        setMember,
        setTeam,
        setStatus,
        setSelectedProjectList,
        setSelectedPropertyList,
        setSelectedCohortList,
        setSelectedStatusList,
        setSelectedMemberList,
        setSelectedTeamList,
        setSelectedDashboardProjectList,
        handleDashboardProject,
        handleDashboardProperty,
      }}
    >
      {props.children}
    </FilterContext.Provider>
  );
};